import React, { useEffect, useState } from 'react';
import './SmartRedirect.css';

const SmartRedirect = () => {
  const [redirecting, setRedirecting] = useState(true);
  const [deviceType, setDeviceType] = useState(null);

  // Deep linking URLs for mobile apps
  // Android Play Store
  const PLAY_STORE_DEEP_LINK = 'market://details?id=com.vahaanbazar.app';
  const PLAY_STORE_FALLBACK = 'https://play.google.com/store/apps/details?id=com.vahaanbazar.app';
  
  // iOS App Store deep link
  const APP_STORE_DEEP_LINK = 'itms-apps://apps.apple.com/in/app/vahaanbazar/id6753955870';
  const APP_STORE_FALLBACK = 'https://apps.apple.com/in/app/vahaanbazar/id6753955870';
  
  const FALLBACK_URL = '/'; // Redirect to home if desktop

  useEffect(() => {
    const detectDeviceAndRedirect = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      
      // Detect if device is Android
      const isAndroid = /android/i.test(userAgent);
      
      // Detect if device is iOS
      const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
      
      // Log for debugging
      console.log('User Agent:', userAgent);
      console.log('Is Android:', isAndroid);
      console.log('Is iOS:', isIOS);

      setTimeout(() => {
        if (isAndroid) {
          setDeviceType('Android');
          redirectToPlayStore();
        } else if (isIOS) {
          setDeviceType('iOS');
          redirectToAppStore();
        } else {
          setDeviceType('Desktop');
          window.location.href = FALLBACK_URL;
        }
      }, 1500);
    };

    const redirectToPlayStore = () => {
      // Try market:// protocol to open Play Store app
      window.location.href = PLAY_STORE_DEEP_LINK;
      
      // If deep link fails (user in browser or protocol not supported)
      // this timeout fallback will open the HTTPS URL after 500ms
      setTimeout(() => {
        window.location.href = PLAY_STORE_FALLBACK;
      }, 500);
    };

    const redirectToAppStore = () => {
      // Try to open App Store app via deep link
      const timeout = setTimeout(() => {
        // If deep link fails (app not installed), fall back to web URL
        window.location.href = APP_STORE_FALLBACK;
      }, 500);

      // Attempt to open via deep link
      window.location.href = APP_STORE_DEEP_LINK;
    };

    detectDeviceAndRedirect();
  }, []);

  return (
    <div className="smart-redirect-container">
      <div className="redirect-content">
        <div className="spinner"></div>
        <h2>Redirecting You...</h2>
        
        {deviceType === 'Android' && (
          <div className="redirect-message">
            <p>🤖 Android Device Detected</p>
            <p className="sub-text">Opening Google Play Store...</p>
          </div>
        )}
        
        {deviceType === 'iOS' && (
          <div className="redirect-message">
            <p>🍎 iOS Device Detected</p>
            <p className="sub-text">Opening App Store...</p>
          </div>
        )}
        
        {deviceType === 'Desktop' && (
          <div className="redirect-message">
            <p>💻 Desktop Device Detected</p>
            <p className="sub-text">Redirecting to VahaanBazar...</p>
            <div className="app-options">
              <p className="options-title">Or download our app:</p>
              <div className="download-links">
                <a 
                  href={PLAY_STORE_FALLBACK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="download-link android-link"
                >
                  📱 Google Play Store
                </a>
                <a 
                  href={APP_STORE_FALLBACK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="download-link ios-link"
                >
                  📱 Apple App Store
                </a>
              </div>
            </div>
          </div>
        )}
        
        {!deviceType && (
          <p className="detecting-text">Detecting your device...</p>
        )}

        <div className="fallback-message">
          <p>If you're not redirected automatically, <a href={FALLBACK_URL} className="fallback-link">click here</a></p>
        </div>
      </div>
    </div>
  );
};

export default SmartRedirect;
